import { PrintDataEntitas } from "@/domain/entities/Booking";
import { FlagsPermissionPrintReceipt } from "@/feature-flags/flags-permission-print-receipt";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { isCourierRecommendation } from "../../module";
import { liolio } from "@/app/ui/modules/receipt-v2/constants/images";

export const viralSection = async (
  params: {
    doc: jsPDF | any;
    startX: number;
    startY: number;
    data: PrintDataEntitas;
  },
  coor: {
    startX: number;
    startY: number;
  },
  translate: Function
) => {
  const urlCampaign = `${process.env.VUE_APP_WEBSITE_LION_PARCEL}/ceocard`;

  const isSTTCAOrRetail =
    params.data.sttBookedForName.toLowerCase() === "customer apps" ||
    params.data.sttNo.startsWith("11LP") ||
    params.data.sttNo.startsWith("10LP");
  const viralCampaignCondition = FlagsPermissionPrintReceipt.permission_campaign_viral_enable.isEnabled() &&
  isSTTCAOrRetail && !params.data.isReverseJourney

    const combineQRTextForRegular = `${process.env.VUE_APP_WEBSITE_LION_PARCEL}/track/stt?q=${params.data.sttNo}`;
    const combineQRTextForCourirRecomendation = JSON.stringify({
      "stt_no": params.data.sttNo,
      "partner_name": params.data.sttBookedForName,
      "booking_id": params.data.otherShipperTicketCode,
    });
      let qrcodeValue = "";
      if (viralCampaignCondition) {
        qrcodeValue = urlCampaign
      }else if (isCourierRecommendation(params.data.sttNoRefExternal)) {
        qrcodeValue = combineQRTextForCourirRecomendation;
      } else {
        qrcodeValue = combineQRTextForRegular;
      }

  const qrcode = await QRCode.toDataURL(qrcodeValue || "", {
    errorCorrectionLevel: "Q",
  }).then((url: string) => {
    return url;
  });
  // BOX
  params.doc.setFillColor(0);
  params.doc.roundedRect(
    coor.startX + 49,
    coor.startY + 108,
    54,
    16.5,
    1,
    1,
    "F"
  );
  const background = await import(
    "@/app/ui/assets/images/bg-qr-section-resi.png"
  );
  params.doc.addImage(
    background.default,
    "PNG",
    coor.startX + 49.25,
    coor.startY + 108.25,
    37.5,
    16,
    undefined,
    "FAST"
  );

  params.doc.addImage(
    liolio,
    "PNG",
    coor.startX + 49.25,
    coor.startY + 109.75,
    14,
    14,
    undefined,
    "FAST"
  );
  
  params.doc.setTextColor("#333333");
  params.doc.setFont("Montserrat", "extrabold");
  params.doc.setFontSize(8);
  params.doc.text(
    translate("receipt.scanHere")?.toUpperCase(),
    coor.startX + 63,
    coor.startY + 113
  );
  params.doc.setFont("Montserrat", "semibold");
  params.doc.setFontSize(6);
  params.doc.text(
    translate("receipt.infoTracking"),
    coor.startX + 63,
    coor.startY + 116
  );

  params.doc.addImage(qrcode, coor.startX + 87.5, coor.startY + 109, 14.5, 14.5);

  params.doc.setLineWidth(1)
  params.doc.roundedRect(
    coor.startX + 87,
    coor.startY + 108.5,
    15.5,
    15.5,
    2,
    2
  );
};
